import { createApi } from "../axiosInstance";
import { createBusinessApi } from "../shared/businessApiFactory";

const api = createApi("myFPO");

export const {
  getMyBusiness,
  getMyBusinessById,
  createMyBusiness,
  updateMyBusiness,
  deleteMyBusiness,
} = createBusinessApi(api);
